export const LANDING = '/';
export const ACCOUNT_SETTINGS = '/settings';
export const SIGN_IN = '/signin';
export const SIGN_UP = '/signup';
export const RESET_PASSWORD = '/reset-password';
export const POLICY = '/policy';
export const POSTS = '/posts';
export const PROFILE = '/profile';
export const MY_ALL_POSTS = '/posts/my';
export const POST = '/posts/:id';
export const CREATE_POST = '/posts/create';
export const UPDATE_POST = '/posts/edit/:id';
export const PREVIEW = '/preview/:id';
export const STRIPE_SUCCESS_AUTH = '/stripe/redirect';
